module.exports = __webpack_public_path__ + "img/document_orange.5b572b02.svg";